import { useRiskyPositions } from 'components/SlideOver/dataSlideOver/data/slideOverAddMission/missionTemplate/missionTemplateRiskyPositions';
import TemplateRiskSection from 'components/SlideOver/dataSlideOver/data/slideOverAddMission/missionTemplate/templateRiskSection';
import { missionDetailText } from './missionDetailTexts';

// While the referential is missing, a factor falls back on its BeSTT key, like
// the job description summary.
const fallbackLabel = (besttField) =>
  besttField.replace(/^Penibilite_/, '').replace(/_/g, ' ');

/**
 * Labels of the factors set on the mission, in the referential order, then
 * the factors the referential does not list.
 */
export const missionRiskFactorLabels = (penibilite, riskyPositions = []) => {
  const selected = Object.keys(penibilite || {}).filter(
    (field) => field.startsWith('Penibilite_') && penibilite[field] === true,
  );
  const listed = riskyPositions.filter(({ besttField }) =>
    selected.includes(besttField),
  );
  const listedFields = listed.map(({ besttField }) => besttField);
  return [
    ...listed.map(({ besttField, name }) => name || fallbackLabel(besttField)),
    ...selected
      .filter((field) => !listedFields.includes(field))
      .map(fallbackLabel),
  ];
};

/**
 * « Poste à risque » sub-tab of the mission detail. Editing, the risk section
 * of the job description wizard runs on `riskForm` (see missionRiskForm.js).
 */
const MissionRiskTab = ({
  infoMission,
  isEditing,
  riskForm,
  onRiskFormChange,
}) => {
  const riskyPositions = useRiskyPositions();

  if (isEditing && riskForm) {
    return (
      <div data-testid="mission-detail-risk">
        <TemplateRiskSection
          positionAtRisk={riskForm.position_at_risk}
          penibilite={riskForm.penibilite}
          onChange={onRiskFormChange}
        />
      </div>
    );
  }

  const factors = missionRiskFactorLabels(
    infoMission?.conditions?.penibilite,
    riskyPositions,
  );

  return (
    <div className="flex flex-col gap-3" data-testid="mission-detail-risk">
      {factors.length > 0 ? (
        <ul className="list-disc pl-5 flex flex-col gap-2 text-gray-700">
          {factors.map((factor) => (
            <li key={factor}>{factor}</li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-500">{missionDetailText('risk.empty')}</p>
      )}
    </div>
  );
};

export default MissionRiskTab;
